const html = require('choo/html')
const Button = require('../elements/button.js')
const InputText = require('../elements/inputtext.js')

module.exports = function InventoryMenu (state, emit) {
  const { selectedInventoryCategory } = state
  const btns = [
    Button({
      color: selectedInventoryCategory === 'glitch' ? 'lightgrey' : 'darkgrey',
      text: 'STICKERS',
      size: 'big',
      type: 'tight',
      id: "stickers-tab",
      onClick: () => emit('select-inventory-category', 'glitch')
    }),
    Button({
      color: selectedInventoryCategory === 'part' ? 'lightgrey' : 'darkgrey',
      text: 'PIECES',
      size: 'big',
      type: 'tight',
      id: "parts-tab",
      onClick: () => emit('select-inventory-category', 'part')
    }),
    /*
    Button({
      color: selectedInventoryCategory === 'packs' ? 'lightgrey' : 'darkgrey',
      text: 'PACKS',
      size: 'big',
      type: 'tight',
      id: "packs-tab",
      onClick: () => emit('select-inventory-category', 'packs')
    }) 
  */
  ]
  const search = InputText({
    placeholder: 'SEARCH',
    id: "inventory-search-field",
    value: state.inventoryFilter,
    onFocus: e => {emit('toggle-glitch-category', 'all')
        emit('select-search-bar')
    },
    onChange: e => emit('change-inventory-filter', e.target.value),
    onKeyUp: e => emit('change-inventory-filter', e.target.value)
  })
  return html`
    <div class="grid-8 inventory-header">
      <div class="column-5 categories">${btns}</div>
      <div class="column-3 search">${search}</div>
    </div>
  `
}
